export const FETCH_RULESET_REQUEST = 'FETCH_RULESET_REQUEST';
export const FETCH_RULESET_SUCCESS = 'FETCH_RULESET_SUCCESS';
export const FETCH_RULESET_FAILURE = 'FETCH_RULESET_FAILURE';
